/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)

import ReactOnRails from 'react-on-rails';

import VendorFinder from '../shared/components/vendor_finder/Demo';
import InvoiceDateDemo from '../shared/components/invoice_date/Demo';
import ItemNameFinder from '../shared/components/item_name_finder/Demo';
import ItemNumberFinder from '../shared/components/item_number_finder/Demo';
import CategorySelector from '../shared/components/category_selector/Demo';
import InvoiceNumber from '../shared/components/invoice_number/Demo';
import InvoiceAmount from '../shared/components/invoice_amount/Demo';
import UnitPrice from '../shared/components/unit_price/Demo';
import Quantity from '../shared/components/quantity/Demo';
import Subtotal from '../shared/components/subtotal/Demo';
import InvoiceFormPlay from '../shared/components/_invoice_form/Play';
import InvoiceFormDemo from '../shared/components/_invoice_form/Demo';
import InvoicePipelinePlayground from '../shared/components/invoice_pipeline_playground/Main';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  VendorFinder,
  InvoiceDateDemo,
  ItemNameFinder,
  ItemNumberFinder,
  CategorySelector,
  InvoiceNumber,
  InvoiceAmount,
  UnitPrice,
  Quantity,
  Subtotal,
  InvoiceFormPlay,
  InvoiceFormDemo,
  InvoicePipelinePlayground,
});
